import { parseStatusDetails } from "../notificationparsers/notificationstatuses/notificationStatusParsers";
import {statusComponentBuilderMap} from './statusComponentBuilderMap';

export function getNotificationStatusComponent(notification) {
  if (!notification.status || !notification.statusDetails) return '';
  const parsedDetailsObj = parseStatusDetails(
    notification.status,
    notification.statusDetails
  );
  const Component = statusComponentBuilderMap[notification.status] ?? null;
  if(Component){
    return [Component, parsedDetailsObj];
  } else return null;
}